import React, {Component} from 'react';
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";

import { withRouter } from "react-router";

import {
  Button,
} from "react-bootstrap";

import { affiliateWidget } from "../../../redux/actions/frontActions";

import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "../../../slider/slider-animations.css";
import "../../../slider/styles.css";

let isLoading = false;
let affiliateID;

const history = createBrowserHistory();

class AffiliateSmall extends Component {

  constructor(props) {
    super(props);
    this.state = {
      widgetImage: '',
      affiliateID: '',
    }
  }

  componentWillMount(){
    let affiliateID = this.props.route.match.params.affiliateID ? this.props.route.match.params.affiliateID : '';
    if(affiliateID){
          isLoading = "true";
      this.setState({ affiliateID: affiliateID });
      this.props.affiliateWidget(affiliateID);
    }
  }

   componentWillReceiveProps(nextProps) {
      if (this.props.widgetImage !== nextProps.widgetImage) {
        if (nextProps.widgetImage) {
          isLoading = "false";
          this.setState({ widgetImage: nextProps.widgetImage.deals });
        }
      }
   }

  render() {
    const { widgetImage } = this.state;
    return (
      <div>
          {isLoading == "true" ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
        {(widgetImage) &&
        <Slider className="slider-wrapper" autoplay={2000} infinite={true}>
          {widgetImage.map((data, key) => 
                  <div
                          key={key}
                          className="slider-content"
                          style={{
                            background: `url('${data.imageurl}${data.image}') no-repeat center center`
                          }}
                        >
                          <div className="inner">
                            <h3 style={{ size: '0.5em'}}>{data.dealText}</h3><br/>
                            <a bsStyle="success" onClick={`/deals-detail/${this.state.affiliateID}`}>Click Here</a>
                          </div>
                      </div>
                ) 
          }
                </Slider>
              }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    widgetImage: state.frontReducer.widgetImage,
    error: state.frontReducer.error
  };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {
    affiliateWidget
  })
)(AffiliateSmall);



// WEBPACK FOOTER //
// ./src/app/views/frontend/Affiliate/AffiliateSmall.js